const text = value => value == null ? '' : String(value).trim()
const typeNames = {
  EXPERIMENT_ASSIGNED: '实验任务', EXPERIMENT_SUBMITTED: '实验提交', REPORT_GENERATED: '报告生成',
  ASSESSMENT_REMINDER: '考核提醒', EXAM_REMINDER: '考核提醒', SYSTEM: '系统通知', SYSTEM_NOTICE: '系统通知'
}
const chineseTypes = ['实验任务', '考核提醒', '系统通知', '报告生成', '实验提交']

export function notificationTypeLabel (item) {
  if (text(item.notificationTypeName)) return item.notificationTypeName
  const type = text(item.notificationType) || text(item.messageType) || text(item.type)
  if (typeNames[type]) return typeNames[type]
  if (chineseTypes.includes(type)) return type
  if (!type || type === 'NOTIFICATION') {
    return { 收到新的实验任务: '实验任务', 实验已提交: '实验提交', 实验报告已生成: '报告生成' }[item.title] || '通知'
  }
  return '其他通知'
}

const usableName = value => text(value) && !['未知用户', 'system'].includes(text(value)) && !/^u_/.test(text(value))
export function needsNotificationNames (item) {
  return !usableName(item.recipientName) || (!usableName(item.senderName) && !usableName(item.fromName))
}

export function displayNotifications (items, users) {
  const names = new Map()
  users.forEach(user => {
    const name = text(user.name) || text(user.displayName)
    if (name && text(user.id)) names.set(text(user.id), name)
    if (name && text(user.account) && !names.has(text(user.account))) names.set(text(user.account), name)
  })
  const personName = (id, saved) => names.get(id) || (usableName(saved) && text(saved) !== id ? text(saved) : '未知用户')
  return items.map(item => {
    const sender = text(item.senderId) || text(item.fromId) || text(item.ownerId)
    return { ...item,
      notificationTypeName: notificationTypeLabel(item),
      recipientName: personName(text(item.recipientId), item.recipientName || item.toName),
      senderName: sender.toLowerCase() === 'system' ? '系统通知' : personName(sender, item.senderName || item.fromName)
    }
  })
}
